import React from 'react'
import _ from 'lodash'

import TextGroup from '../Texts'

const StrategyOne = ({ lang }) => {
const isEn = lang === 'en';
  return (
    <section id="strategy-one" className="content container">
      <TextGroup
        rootProps={{ className: 'align-center' }}
        title={{
          type: 'h1',
          text: isEn ? 'ESG Strategy - Environmental, Social And Corporate Governance' : 'Estratégia ESG - Environmental, Social And Corporate Governance',
        }}
      />
      {isEn ? (
        <>
        <p>The ESG strategy is a fundamental commitment of log.oscon. We recognise the
importance of Environmental, Social and Governance factors in our business and
are committed to aligning our operations and practices with the highest ESG
standards</p>
        <p>log.oscon is aware that it must set an example in the way it carries out its activity.
In this context, log.oscon seeks to reinforce its corporate integrity by striving to
improve the service it provides, making responsible decisions in the way it runs its
business, and actively managing the social and environmental impacts of what it
does to help individuals, communities, companies and economies progress and
grow.</p>
        <p>log.oscon's aim is to promote excellence in these areas through its own
organisation, and to support and positively influence the development of these
areas in its supply chain.</p>
        <p>log.oscon is also committed to helping people achieve their ambitions. This
includes its employees, customers and partners and is achieved by demonstrating
log.oscon's values to those who interact with them.</p>

        <h3>Unit</h3>
        <p>We respect and value the people we work with. We embrace diversity and inclusive
practice.</p>

        <h3>Integrity</h3>
        <p>We value transparency, communicate honestly and share information openly. We
act with integrity in everything we do. We don't hide our mistakes and we learn
from them.</p>

        <h3>Agility</h3>
        <p>We act with a sense of urgency and determination. We are agile, adaptable,
reactive and accept change. We take intelligent risks.</p>

        <h3>Energy</h3>
        <p>We are positively motivated to make a difference and challenge the status quo. We
encourage personal leadership. We motivate each other with our ambition.</p>

        <h3>Responsability</h3>
        <p>We provide maximum value to our employees, customers and partners. We take
responsibility and are accountable for results. We reward and celebrate
performance.</p>

        <h2>Principles</h2>
        <p>log.oscon supports the following principles:</p>
        <ul>
            <li>Compliance with all applicable laws and regulations of the countries in which it operates;</li>
            <li>Support and respect for the protection of internationally recognised human rights;</li>
            <li>Don't be complicit in human rights violations;</li>
            <li>No use of any form of forced or compulsory labour or child labour;</li>
            <li>Prevent discrimination in employment and occupation;</li>
            <li>Supporting a preventive approach to environmental challenges;</li>
            <li>Undertake initiatives to promote greater environmental responsibility;</li>
            <li>Encouraging the development and dissemination of environmentally friendly technologies;</li>
            <li>Work against corruption in all its forms, including extortion and bribery.</li>
        </ul>
        <p>log.oscon makes these principles the main factors in its purchasing policy.</p>

        <h2>Environmental Strategy (E)</h2>
        <h3>Reducing Carbon Emissions</h3>
        <p>We are committed to reducing our carbon footprint by implementing energy
efficiency practices and promoting sustainable transport alternatives for our
employees.</p>

        <h3>Energy Efficiency</h3>
        <p>We invest in technologies and practices that reduce energy consumption, such as
upgrading lighting systems, insulating the building and using more energy-efficient
equipment.</p>

        <h3>Sustainable transport</h3>
        <p>We encourage the use of public transport, electric or hybrid cars to reduce the
        carbon emissions associated with business travel and employee commuting. We
        have incorporated electric vehicles into our car fleet.</p>

        <h3>Video conferences</h3>
        <p>Video calls should replace the need for frequent business trips, which could
        significantly reduce the carbon emissions associated with air and land transport.</p>

        <h3>Electronic Waste Management</h3>
        <p>We adopt responsible electronic waste management practices, promoting the
        recycling and reuse of obsolete equipment.</p>

        <h3>Renewable Energies</h3>
        <p>We will investigate the feasibility of using renewable energy sources to power our
        operations, thus reducing our dependence on fossil fuels.</p>

        <h3>Adoption Of A More Responsible Purchasing Policy</h3>
        <p>We prioritise choosing suppliers who demonstrate sustainable practices in relation
        to the environment, such as reducing carbon emissions, responsible use of natural
        resources and proper waste management.
        We avoid buying single-use plastic products and opt for more sustainable
        alternatives, such as reusable or biodegradable packaging.</p>

        <h3>Paperless Work</h3>
        <p>We excluded individual printers and switched to paperless work processes.</p>

        <h2>Social Strategy (S)</h2>
        <h3>Diversity and Inclusion</h3>
        <p>We actively promote diversity and inclusion in all areas of our company, fostering a
        working environment that values differences and offers equal opportunities to all
        employees</p>

        <h3>Skills Development</h3>
        <p>We invest in the training and continuous development of our employees, ensuring
that everyone has access to learning opportunities and professional growth.</p>

        <h3>Responsibility to the Community</h3>
        <p>We are committed to carrying out corporate social responsibility actions, including
volunteering programmes and supporting local initiatives that benefit the
communities where we operate.</p>

        <h3>Social Solidarity</h3>
        <p>We support charitable organisations.</p>

        <h2>Corporate Governance Strategy (G)</h2>
        <h3>Business Ethics</h3>
        <p>We maintain the highest ethical standards in all our operations, promoting
transparency, responsibility and integrity.</p>
        <p>We promote diversity, encourage the exchange of knowledge and support our
employees.</p>
        <p>The gender balance in the workplace<sup>1</sup> is represented by a proportion of 34 per cent women and 66 per cent men.</p>
        <p>We work with professional ethics and have independent management</p>
        <ul>
        <li><a href="/en/code-ethics-conduct/">Code of Ethics and Conduct</a></li>
        <li><a href="/en/anti-corruption-policy/">Anti-Corruption Policy</a></li>
        <li><a href="/en/complaints-management-policy/">Complaints Management Policy</a></li>
        <li><a href="/en/privacy-policy/">Privacy and data protection policy</a></li>
        </ul>

        <p></p>
        <p><sup>1</sup>Data at Group level.</p>

        <h3>Risk Management</h3>
        <p>We will implement robust risk management practices, identifying and addressing
potential ESG risks that could affect our business.</p>

        <h3>Continuous training</h3>
        <p>We offer continuous training for all employees.</p>

        <h3>Transparency</h3>
        <p>We share our results with our employees.</p>

        <h3>ESG reporting</h3>
        <p>We are committed to regularly disclosing transparent and complete information on
our ESG performance, allowing our stakeholders to assess our progress.</p>
        <p>This ESG strategy reflects our commitment to sustainability, corporate
responsibility and alignment with global best practice.</p>
        <p>We are determined to play a positive role in society and the environment, while
ensuring the sustainable growth of our Information Technology business.</p>
        </>
      ) : (
        <>
      <p>A estratégia ESG é um compromisso fundamental da log.oscon. Reconhecemos a
importância dos fatores Ambientais, Sociais e de Governação no nosso negócio e
estamos empenhados em alinhar as nossas operações e práticas com os mais
elevados padrões ESG.</p>
        <p>A log.oscon está consciente de que deve dar o exemplo na forma como exerce a
sua atividade. Neste contexto, a log.oscon procura reforçar a sua integridade
empresarial, esforçando-se por melhorar o serviço que presta, tomando decisões
responsáveis na forma como gere o seu negócio, e gerindo ativamente os impactos
sociais e ambientais do que faz para ajudar os indivíduos, as comunidades, as
empresas e as economias a progredir e a crescer.</p>
        <p>O objetivo da log.oscon é promover a excelência nestas áreas através da sua
própria organização, e apoiar e influenciar positivamente o desenvolvimento destas
áreas na sua cadeia de fornecimento.</p>
        <p>A log.oscon está também empenhada em ajudar as pessoas a alcançar as suas
ambições. Este objetivo inclui os seus colaboradores, clientes e parceiros e é
alcançado através da demonstração dos valores da log.oscon por aqueles que
interagem com eles.</p>

        <h3>Unidade</h3>
        <p>Respeitamos e valorizamos as pessoas com quem trabalhamos. Abraçamos a
diversidade e a práctica inclusiva.</p>

        <h3>Integridade</h3>
        <p>Valorizamos a transparência, comunicamos honestamente e partilhamos
informações abertamente. Agimos com integridade em tudo o que fazemos. Não
escondemos os nossos erros e aprendemos com eles.</p>

        <h3>Agilidade</h3>
        <p>Agimos com um sentido de urgência e determinação. Somos ágeis, adaptáveis,
reactivos e aceitamos a mudança. Assumimos riscos inteligentes.</p>

        <h3>Energia</h3>
        <p>Somos motivados positivamente para fazer a diferença e desafiar o status quo.
Incentivamos a liderança pessoal. Motivamo-nos uns aos outros com a nossa
ambição.</p>

        <h3>Responsabilidade</h3>
        <p>Proporcionamos o máximo valor aos nossos colaboradores, clientes e parceiros.
Assumimos a responsabilidade e somos responsáveis pelo resultado.
Recompensamos e celebramos o desempenho.</p>

        <h2>Princípios</h2>
        <p>A log.oscon apoia os seguintes princípios:</p>
        <ul>
            <li>Cumprimento de todas as leis e regulamentos aplicáveis dos países em que opera;</li>
            <li>Apoio e respeito à proteção dos direitos humanos reconhecidos internacionalmente;</li>
            <li>Não ser cúmplice de violações dos direitos humanos;</li>
            <li>Não recorrer a quaisquer formas de trabalho forçado ou obrigatório ou de trabalho infantil;</li>
            <li>Impedir a discriminação em matéria de emprego e de profissão;</li>
            <li>Apoiar uma abordagem preventiva dos desafios ambientais;</li>
            <li>Empreender iniciativas para promover uma maior responsabilidade ambiental;</li>
            <li>Incentivar o desenvolvimento e a difusão de tecnologias respeitadoras do ambiente;</li>
            <li>Trabalhar contra a corrupção em todas as suas formas, incluindo a extorsão e o suborno.</li>
        </ul>
        <p>A log.oscon faz destes princípios os principais factores da sua política de compras.</p>

        <h2>Estratégia Ambiental (E)</h2>
        <h3>Redução Das Emissões De Carbono</h3>
        <p>Comprometemo-nos a reduzir a nossa pegada de carbono através da
        implementação de práticas de eficiência energética e da promoção de alternativas
        de transporte sustentável para os nossos colaboradores.</p>

        <h3>Eficiência Energética</h3>
        <p>Investimos em tecnologias e práticas que reduzem o consumo de energia, como a
        atualização de sistemas de iluminação, isolamento térmico do edifício e o uso de
        equipamentos mais eficientes em termos energéticos.</p>

        <h3>Transporte Sustentável</h3>
        <p>Incentivamos o uso de transportes públicos, carros elétricos ou híbridos para
        reduzir as emissões de carbono associadas às viagens de negócios e ao
        deslocamento dos funcionários. Incorporámos veículos elétricos na nossa frota
        automóvel.</p>

        <h3>Videoconferências</h3>
        <p>As videochamadas devem substituir a necessidade de viagens de negócios
        frequentes, o que pode reduzir significativamente as emissões de carbono
        associadas ao transporte aéreo e terrestre.</p>

        <h3>Gestão De Resíduos Eletrónicos</h3>
        <p>Adotamos práticas de gestão responsável de resíduos eletrónicos, promovendo a
        reciclagem e a reutilização de equipamentos obsoletos.</p>

        <h3>Energias Renováveis</h3>
        <p>Investigaremos a viabilidade de utilizar fontes de energia renovável para alimentar
        as nossas operações, reduzindo assim a nossa dependência de combustíveis
        fósseis.</p>

        <h3>Adotação De Uma Política De Compras Mais Responsável</h3>
        <p>Priorizamos a escolha de fornecedores que demonstrem práticas sustentáveis em
        relação ao meio ambiente, como a redução das emissões de carbono, uso
        responsável dos recursos naturais e gestão adequada de resíduos.
        Evitamos a compra de produtos de plástico de uso único e optamos por
        alternativas mais sustentáveis, como embalagens reutilizáveis ou biodegradáveis.</p>

        <h3>Trabalho Sem Papel</h3>
        <p>Procedemos à exclusão de impressoras individuais e transitámos para processos
        de trabalho sem papel.</p>

        <h2>Estratégia Social (S)</h2>
        <h3>Diversidade E Inclusão</h3>
        <p>Promovemos ativamente a diversidade e inclusão em todas as áreas da nossa
        empresa, fomentando um ambiente de trabalho que valoriza as diferenças e
        oferece igualdade de oportunidades a todos os colaboradores.</p>

        <h3>Desenvolvimento De Competências</h3>
        <p>Investimos na formação e desenvolvimento contínuo dos nossos colaboradores,
        garantindo que todos tenham acesso a oportunidades de aprendizagem e
        crescimento profissional.</p>

        <h3>Responsabilidade Para Com A Comunidade</h3>
        <p>Comprometemo-nos a realizar ações de responsabilidade social corporativa,
        incluindo programas de voluntariado e apoio a iniciativas locais que beneficiem as
        comunidades onde operamos.</p>

        <h3>Solidariedade Social</h3>
        <p>Apoiamos instituições de solidariedade social.</p>

        <h2>Estratégia De Corporate Governance (G)</h2>
        <h3>Ética Empresarial</h3>
        <p>Mantemos os mais altos padrões éticos em todas as nossas operações,
        promovendo a transparência, a responsabilidade e a integridade.</p>
        <p>Promovemos a diversidade, incentivamos a troca de conhecimento e apoiamos os
        nossos colaboradores.</p>
        <p>O equilíbrio de género no local de trabalho<sup>1</sup> é representado por uma proporção de 34% de mulheres e 66% de homens.</p>
        <p>Trabalhamos com ética profissional e temos uma gestão independente.</p>
        <ul>
        <li><a href="/codigo-etica-conduta/">Código de Ética e Conduta</a></li>
        <li><a href="/politica-anticorrupcao/">Política de Anticorrupção</a></li>
        <li><a href="/politica-gestao-reclamacoes/">Política de Gestão de Reclamações</a></li>
        <li><a href="/politica-privacidade/">Política de privacidade e proteção de dados</a></li>
        </ul>

        <p></p>
        <p><sup>1</sup>Dados referentes a nível do Grupo.</p>

        <h3>Gestão De Riscos</h3>
        <p>Implementaremos práticas robustas de gestão de riscos, identificando e abordando
        potenciais riscos ESG que possam afetar o nosso negócio.</p>

        <h3>Formação Contínua</h3>
        <p>Oferecemos formação contínua para todos os colaboradores.</p>

        <h3>Transparência</h3>
        <p>Partilhamos os nossos resultados com os nossos colaboradores.</p>

        <h3>Reporte ESG</h3>
        <p>Comprometemo-nos a divulgar regularmente informações transparentes e
        completas sobre o nosso desempenho ESG, permitindo que os nossos
        stakeholders avaliem o nosso progresso.</p>
        <p>Esta estratégia ESG reflete o nosso compromisso com a sustentabilidade, a
        responsabilidade corporativa e o alinhamento com as melhores práticas globais.</p>
        <p>Estamos determinados a desempenhar um papel positivo na sociedade e no meio
        ambiente, ao mesmo tempo que asseguramos o crescimento sustentável do nosso
        negócio de Tecnologia da Informação.</p>
        </>
        )}
    </section>
  )
}
export default StrategyOne
